import { FormExtractorService } from "../../../shared/services/form-extractor.service";
import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_500 implements Validator {

    public static id = 'CTRL_500';
    private message = 'error.ctr_500';


    public LOG: LogService = new LogService(CTRL_500);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_500.id + '_');

        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const objetPrinCp = ctrl.value.rgCtrls.objetPrinCp;
                const objetPrinCs = ctrl.value.rgCtrls.objetPrinCs;
                const objetCompCp = ctrl.value.rgCtrls.objetCompCp;
                const objetCompCs = ctrl.value.rgCtrls.objetCompCs;

                const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
                let controlsNameCpv = [];
                let numLot = rg.substr(rg.length - 1);
                const objetComplementaireIters = this.formExtractorService.getIndexes(Array.from(controls.keys()), [objetCompCp.split('INDEX')[0] + numLot, '_SepAtt_classPrincipale'], '_SepSep_Lot_SepSep_TypeObjCPV_index_');
                controlsNameCpv.push(objetPrinCp.replace('INDEX_500_1', numLot));
                controlsNameCpv.push(objetPrinCs.replace('INDEX_500_1', numLot));
                for (var i = 1; i <= objetComplementaireIters.size; i++) {
                    controlsNameCpv.push(objetCompCp.replace('INDEX_500_1', numLot).replace('INDEX_500_2', i));
                    controlsNameCpv.push(objetCompCs.replace('INDEX_500_1', numLot).replace('INDEX_500_2', i));
                }
                let valuesCpv = [];
                for (var i = 0; i < controlsNameCpv.length; i++) {
                    if (Array.isArray(form.controls[map.get(controlsNameCpv[i])].value)) {
                        form.controls[map.get(controlsNameCpv[i])].value?.forEach(function(item){
                            valuesCpv.push(item);
                            })
                    } else {
                        valuesCpv.push(form.controls[map.get(controlsNameCpv[i])].value);
                    }
                }
                if (valuesCpv.filter((item, i, ar) => ar.indexOf(item) === i).length === valuesCpv.length) {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
            }
        }
    }
}